import { BankAccountChequeBook } from '../../../types/bank-account/BankAccountChequeBook';
import React from 'react';
import { Box, Button, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

export interface AccountChequeBookControllerProps {
  chequeBook: BankAccountChequeBook;
  onIncrementClicked?: (negative: boolean) => void;
  onNewChequeBookClicked?: () => void;
}

export const AccountChequeBookController = (
  props: AccountChequeBookControllerProps,
) => {
  const { chequeBook, onIncrementClicked, onNewChequeBookClicked } = props;

  const isOutOfBounds =
    chequeBook.currentChequeNumber > chequeBook.maxChequeNumber;

  return (
    <Box>
      <Button
        sx={{ marginRight: 1 }}
        variant={'outlined'}
        color={'primary'}
        onClick={onNewChequeBookClicked}
      >
        Nouveau chéquier...
      </Button>
      <IconButton
        disabled={chequeBook.currentChequeNumber <= 1}
        onClick={() => onIncrementClicked?.(true)}
        size="large"
      >
        <Remove />
      </IconButton>
      <IconButton onClick={() => onIncrementClicked?.(false)} size="large">
        <Add />
      </IconButton>
      {isOutOfBounds ? <div>Le chéquier est terminé.</div> : null}
    </Box>
  );
};
